import { guardedCustomElement } from '../utils/guarded-custom-element';
import { SheriffEvent } from '../types';
import { SDSAlertComponent } from './sds-alert.component';

import '../sds-icon/sds-icon';
import '../sds-button/sds-button';

@guardedCustomElement('sds-alert')
export class SDSAlert extends SDSAlertComponent {}

declare global {
	interface HTMLElementTagNameMap {
		'sds-alert': SDSAlert;
	}
	interface GlobalEventHandlersEventMap {
		'sds-remove': SheriffEvent;
	}
}
